<template>
  <div>
    <el-form
      label-position="left"
      label-width="150px"
      ref="localUser"
      :model="localUser"
      :rules="rules"
    >
      <el-form-item label="Email" prop="email">
        <el-input v-model="localUser.email" placeholder="Email"></el-input>
      </el-form-item>

      <el-form-item label="Name" prop="first_name">
        <el-input v-model="localUser.first_name" placeholder="Name"></el-input>
      </el-form-item>

      <el-form-item label="Surname" prop="last_name">
        <el-input v-model="localUser.last_name" placeholder="Surname"></el-input>
      </el-form-item>

      <el-form-item label="Job Title" prop="job_title">
        <el-input v-model="localUser.job_title" placeholder="Job Title"></el-input>
      </el-form-item>

      <el-form-item label="Groups" prop="groups">
        <el-select
          multiple
          placeholder="Select Groups"
          v-model="localUser.groups"
          :disabled="!this.loggedInUser.is_admin"
        >
          <el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Tags" prop="tags">
        <el-tag
          v-for="tag in localUser.tags"
          :key="tag"
          closable
          :disable-transitions="false"
          @close="handleCloseTag(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="tagInputVisible"
          v-model="tagInputValue"
          ref="saveTagInput"
          size="mini"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="handleShowTagInput">
          + New Tag
        </el-button>
      </el-form-item>

      <el-form-item label="Company Admin" prop="is_admin">
        <el-switch
          v-model="localUser.is_admin"
          active-text="Yes"
          inactive-text="No"
          :disabled="!this.loggedInUser.is_admin"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer clearfix">
      <span class="pull-right">
        <el-button id="cancel" type="danger" @click="cancel" plain>Cancel</el-button>
        <el-button id="save" type="primary" :loading="savingUser" @click="handleFormSave" plain
          >Save</el-button
        >
      </span>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserManage',
  props: ['groups', 'user', 'loggedInUser'],

  data: () => ({
    savingUser: false,
    localUser: {},
    rules: {
      email: [{ required: true, message: 'Please provide an email address' }],
      first_name: [{ required: true, message: 'Please provide a name' }],
      last_name: [{ required: true, message: 'Please provide a surname' }],
      job_title: [{ required: true, message: 'Job title is required' }],
      groups: [{ required: true, message: 'Please assign at least one group' }],
    },
    groupRoles: {
      1: { title: 'Company Admin', role: 2 },
      2: { title: 'Organisation Admin', role: 2 },
      3: { title: 'Regular User', role: 1 },
    },
    tagInputVisible: false,
    tagInputValue: '',
  }),

  mounted() {
    /**
     * Deep copy user for for the form so that state is not directly mutated in child component
     */
    this.localUser = { ...this.user };
  },

  computed: {
    ...mapState('user', ['updateCompanyUserRequest', 'updateCompanyUserSucceeded']),
  },

  methods: {
    handleFormSave() {
      this.$refs.localUser.validate(valid => {
        if (valid) return this.saveUser();
        return false;
      });
    },

    saveUser() {
      this.handleUserRole();
      return this.$store.dispatch('user/saveUser', this.localUser);
    },

    cancel() {
      this.$emit('cancelled');
    },

    handleUserRole() {
      const groups = this.localUser.groups;
      this.localUser.role =
        groups.length > 1
          ? this.groupRoles[Math.min(...groups)].role
          : this.groupRoles[groups[0]].role;
    },

    handleShowTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleCloseTag(tag) {
      const index = this.localUser.tags.indexOf(tag);
      this.localUser.tags.splice(index, 1);
    },

    handleInputConfirm() {
      const inputValue = this.tagInputValue;

      // Ensure tags is a list, on old users it may be null
      if (!this.localUser.tags) {
        this.localUser.tags = [];
      }

      if (inputValue) {
        this.localUser.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
  },

  watch: {
    updateCompanyUserRequest(val, oldVal) {
      if (val !== oldVal && val) {
        this.savingUser = true;
      }

      if (!val) {
        this.savingUser = false;
        this.$emit(this.updateCompanyUserSucceeded ? 'saved' : 'saveError', this.user);
      }
    },
  },
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>

<style scoped>
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  font-weight: bold;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// UserManage.vue?a72e8e4a